import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';
import { Gavel, Clock, ShieldAlert, LogOut, RefreshCw } from 'lucide-react';
import './PendingApproval.css';

const PendingApproval = () => {
  const { currentUser, userData, fetchUserData } = useAuth();

  const handleRefresh = async () => {
    if (currentUser) {
      await fetchUserData(currentUser.uid);
      window.location.reload();
    }
  };

  const handleSignOut = () => {
    signOut(auth);
  };

  return (
    <div className="pending-court-container">
      <div className="pending-card">
        <div className="court-emblem">
          <Gavel size={48} className="gavel-icon" />
        </div>
        <h1 className="court-title">The Kangaroo Court</h1>
        <div className="status-badge">
          <Clock size={16} />
          <span>Bar Admission Pending</span>
        </div>
        
        <p className="pending-message">
          Greetings, <strong>{userData?.name || currentUser?.displayName || currentUser?.email}</strong>.
        </p>
        <p className="pending-submessage">
          Access to the Docket, Jury Box, and the Vault of Shame is restricted to verified members of this circle.
          The <strong>Chief Justice (Admin)</strong> has been notified to review and admit your membership.
        </p>

        <div className="court-notice-box">
          <ShieldAlert size={20} className="notice-icon" />
          <div>
            <strong>Private Syndicate Rules:</strong>
            <p>Once admitted, all case filings, evidence drops, and jury roasts stay strictly within the Bar.</p>
          </div>
        </div>

        <div className="pending-actions">
          <button className="btn-court-refresh" onClick={handleRefresh}>
            <RefreshCw size={18} />
            Check Admission Status
          </button>
          <button className="btn-court-signout" onClick={handleSignOut}>
            <LogOut size={18} />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
